import { MobiDocument } from './MobiDocument';
import { Ville } from './Ville';

export class AdresseListeDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private complement: string;
    private numero: string;
    private ville_id: number;
    private voie_id: number;

    public constructor(adresseList: any) {
        super()
        this._id = adresseList._id;
        this._rev = adresseList._rev;
        this.id = adresseList.id;
        this.complement = adresseList.complement;
        this.numero = adresseList.numero;
        this.ville_id = adresseList.ville_id;
        this.voie_id = adresseList.voie_id
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getComplement(): string {
        return this.complement;
    }

    public setComplement(complement: string): void {
        this.complement = complement;
    }

    public getNumero(): string {
        return this.numero;
    }

    public setNumero(numero: string): void {
        this.numero = numero;
    }

    public getVille_id(): number {
        return this.ville_id;
    }

    public setVille_id(ville_id: number): void {
        this.ville_id = ville_id;
    }

    public getVoie_id(): number {
        return this.voie_id;
    }

    public setVoie_id(voie_id: number): void {
        this.voie_id = voie_id;
    }

    public getVille(): Ville {
       return this.memdb.findOne({
            doctype: "VilleDocument",
            fkey: "id",
            fvalue: this.ville_id
        });
    }

}